export const COUNTRIES_ISO_3 = {
    AUT: 'AUT',
    DEU: 'DEU',
    ESP: 'ESP',
    FRA: 'FRA',
    GBR: 'GBR',
    IRL: 'IRL',
    NLD: 'NLD',
};
export const REGIONS = {
    DEU: 'DEU',
    GBR: 'GBR',
};
//# sourceMappingURL=domain.js.map